import { financials_prepared } from '../data/data';

export default {
    section: 'Section 5: Annual Expenses',
    name: 'expenses',
    items: [
        {
            text: 'The expense information provided is from:',
            type: 'selectlist',
            name: 'expenses-from',
            props: {
                items: [
                    {
                        text: 'Current Year',
                        value: 'current'
                    },
                    {
                        text: 'Projected',
                        value: 'projected'
                    },
                    {
                        text: 'Trailing 12 months',
                        value: 'trailing'
                    }
                ],
                label: 'Please select an option'
            }
        },
        {
            text: 'Total Compensation (excluding owner)',
            type: 'text-field',
            name: 'expenses-total-compensation',
            props: {
                prependIcon: 'mdi-currency-usd',
                readonly: true,
                tooltip: 'This value will be calculated from questions a-d.',
                formula: {
                    name: 'sum',
                    arguments: {
                        targets: [
                            'expenses-salary',
                            'expenses-health-insurance',
                            'expenses-401k',
                            'expenses-compensation-other'
                        ]
                    }
                }
            },
            subItems: [
                {
                    text: 'a. W-2 Salary, bonuses, commissions, GDC splits',
                    type: 'text-field',
                    name: 'expenses-salary',
                    props: {
                        format: 'number',
                        prependIcon: 'mdi-currency-usd'
                    }
                },
                {
                    text: 'b. Health Insurance Benefits',
                    type: 'text-field',
                    name: 'expenses-health-insurance',
                    props: {
                        format: 'number',
                        prependIcon: 'mdi-currency-usd'
                    }
                },
                {
                    text: 'c. 401k, Profit Sharing, SEP',
                    type: 'text-field',
                    name: 'expenses-401k',
                    props: {
                        format: 'number',
                        prependIcon: 'mdi-currency-usd'
                    }
                },
                {
                    text: 'd. Other (i.e. tuition reimbursement)',
                    type: 'text-field',
                    name: 'expenses-compensation-other',
                    props: {
                        format: 'number',
                        prependIcon: 'mdi-currency-usd'
                    }
                },
                {
                    text: 'Description of other compensation methods',
                    type: 'textarea',
                    name: 'expenses-other-description',
                    dependencies: {
                        items: [
                            {
                                name: 'expenses-compensation-other',
                                operator: 'isDefined'
                            }
                        ]
                    }
                }
            ]
        },
        {
            text: '1099 Contractor Compensation',
            type: 'text-field',
            name: 'expenses-contractor-compensation',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Referral Fees Paid in Perpetuity',
            type: 'text-field',
            name: 'expenses-referral-fees',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Annual Advertising/Marketing',
            type: 'text-field',
            name: 'expenses-advertising',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Annual Software Costs',
            type: 'text-field',
            name: 'expenses-software',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Annual Lease/Rent',
            type: 'text-field',
            name: 'expenses-lease-rent',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            },
            subItems: [
                {
                    text: '',
                    type: 'radio-list',
                    name: 'expenses-lease-rent-type',
                    props: {
                        items: [
                            {
                                text: 'Home Office',
                                value: 'home-office'
                            },
                            {
                                text: 'Rent/Lease',
                                value: 'rent-lease'
                            },
                            {
                                text: 'Own',
                                value: 'own'
                            }
                        ],
                        row: true
                    }
                },
                {
                    text: '# of Years Renaming on Lease',
                    type: 'text-field',
                    name: 'expenses-lease-rent-remaining',
                    props: {
                        format: 'number'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'expenses-lease-rent-type',
                                value: 'rent-lease'
                            }
                        ]
                    }
                },
                {
                    text: 'Approximate Square Footage',
                    type: 'text-field',
                    name: 'expenses-lease-rent-square-footage',
                    props: {
                        format: 'number'
                    }
                }
            ]
        },
        {
            text: 'Annual Office Supplies',
            type: 'text-field',
            name: 'expenses-office-supplies',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Annual Licensing Costs',
            type: 'text-field',
            name: 'expenses-licensing',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Automobile',
            type: 'text-field',
            name: 'expenses-automobile',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Business Gifts',
            type: 'text-field',
            name: 'expenses-business-gifts',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Continuing Education and Professional Development',
            type: 'text-field',
            name: 'expenses-professional-development',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Dues & Subscriptions',
            type: 'text-field',
            name: 'expenses-subscriptions',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Insurance (other than health)',
            type: 'text-field',
            name: 'expenses-insurance',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Meals & Entertainment',
            type: 'text-field',
            name: 'expenses-entertainment',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Other Expenses',
            type: 'text-field',
            name: 'expenses-other',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Professional Services (accountant, attorney)',
            type: 'text-field',
            name: 'expenses-professional-services',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Payroll Taxes',
            type: 'text-field',
            name: 'expenses-payroll-taxes',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Repairs and Maintenance',
            type: 'text-field',
            name: 'expenses-maintenance',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Travel',
            type: 'text-field',
            name: 'expenses-travel',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Utilities',
            type: 'text-field',
            name: 'expenses-utilities',
            props: {
                format: 'number',
                prependIcon: 'mdi-currency-usd',
            }
        },
        {
            text: 'Do you have debt?',
            type: 'radio-list',
            name: 'expenses-debt',
            props: {
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ],
                row: true
            },
            subItems: [
                {
                    text: 'Who holds the liability?',
                    type: 'selectlist',
                    name: 'expenses-debt-holder',
                    props: {
                        items: [
                           {
                               text: 'Other',
                               value: '0'
                           },
                           {
                                text: 'Personally Held / Personally Liable',
                                value: '1'
                            },
                            {
                                text: 'Held By Entity',
                                value: '2'
                            },
                            {
                                text: 'Co-Borrowed',
                                value: '3'
                            }
                        ],
                        label: 'Please select an option'
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'expenses-debt',
                                value: 'yes'
                            }
                        ]
                    }
                },
                {
                    text: 'How much is outstanding debt?',
                    type: 'text-field',
                    name: 'expenses-debt-outstanding',
                    props: {
                        format: 'number',
                        prependIcon: 'mdi-currency-usd',
                    },
                    dependencies: {
                        items: [
                            {
                                name: 'expenses-debt',
                                value: 'yes'
                            }
                        ]
                    }
                },
            ]
        },
        {
            text: 'How are your financial prepared?',
            type: 'selectlist',
            name: 'expenses-financials-prepared',
            props: {
                items: financials_prepared,
                label: 'Please select an option'
            }
        },
        {
            text: 'Total annual overhead (excluding owner compensation)',
            type: 'text-field',
            name: 'expenses-total-overhead',
            props: {
                prependIcon: 'mdi-currency-usd',
                readonly: true,
                tooltip: 'This value will be calculated from questions 3-22.',
                formula: {
                    name: 'sum',
                    arguments: {
                        targets: [
                            'expenses-401k',
                            'expenses-advertising',
                            'expenses-automobile',
                            'expenses-business-gifts',
                            'expenses-compensation-other',
                            'expenses-contractor-compensation',
                            'expenses-entertainment',
                            'expenses-health-insurance',
                            'expenses-insurance',
                            'expenses-lease-rent',
                            'expenses-licensing',
                            'expenses-maintenance',
                            'expenses-office-supplies',
                            'expenses-other',
                            'expenses-payroll-taxes',
                            'expenses-professional-development',
                            'expenses-professional-services',
                            'expenses-referral-fees',
                            'expenses-salary',
                            'expenses-software',
                            'expenses-subscriptions',
                            'expenses-travel',
                            'expenses-utilities'
                        ]
                    }
                }
            }
        },
        {
            text: 'Please provide your balance sheet',
            type: 'data-table',
            name: 'expenses-balance-sheet',
            props: {
                headers: [
                    {
                        text: 'File Name',
                        value: 'filename'
                    },
                    {
                        text: 'File Size',
                        value: 'filesize'
                    }
                ],
                isFileUpload: true,
                newItemLabel: 'Upload a File',
                noDataLabel: 'Please Upload a Balance Sheet'
            }
        },
        {
            text: 'Please provide a file documenting your profit and loss',
            type: 'data-table',
            name: 'expenses-profit-loss',
            props: {
                headers: [
                    {
                        text: 'File Name',
                        value: 'filename'
                    },
                    {
                        text: 'File Size',
                        value: 'filesize'
                    }
                ],
                isFileUpload: true,
                newItemLabel: 'Upload a File',
                noDataLabel: 'Please Upload a File'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/valuation/valuation-data/expenses.js